import React, { useEffect, useState } from 'react';
import { Typography, Button, Paper, Box, FormControl, TextField, IconButton, Switch, Input } from "@mui/material";
import Editor from '../../components/EditorTemplate/Editor';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { clearMessage } from '../../redux/Slice/message';
import { setLoading } from '../../redux/Slice/loaderSlice';
import FormFields from '../../components/EditorTemplate/FormFields';
import SaveDialog from '../../components/EditorTemplate/HelperDialog/SaveDialog';
import { getQuoteById, updateQuote } from '../../redux/Slice/quoteSlice';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import DynamicForm from '../../components/EditorTemplate/DynamicForm';
import Grid from "@mui/material/Grid2"

const EditTem = () => {
    const [templateName, setTemplateName] = useState("");
    const [inputSchema, setInputSchema] = useState({ data: {}, system: "" });
    const [ContextSchema, setContextSchema] = useState([]);
    const [outputSchema, setOutputSchema] = useState({ data: {}, system: "" });
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const id = params?.id;
    const message = useSelector((state) => state.message);
    const { quoteDetails } = useSelector((state) => state.quote);
    console.log("quoteDetails:",quoteDetails);
    console.log("ContextSchema:",ContextSchema);

    // useEffect(() => {
    //     if (message?.message) {
    //         toast(message?.message);
    //         dispatch(clearMessage());
    //     }
    // }, [message, dispatch]);

    useEffect(() => {
        const value = Object.values(inputSchema.data || []);
        const filteredSchema = ContextSchema.filter(item1 => value.some(item2 => item1.type === item2.type));
        const filteredValue = value.filter(item1 => !ContextSchema.some(item2 => item1.type === item2.type));

        const prevData = filteredValue.map((data) => ({
          data: {},
          system: "",
          title: data.placeholder,
          type: data.type,
          status: false,
          isEditable: false,
      }));

        if(inputSchema){
          setContextSchema([...filteredSchema, ...prevData]);

        // setContextSchema((prev) => {
        //     const prevData = value.map((data) => ({
        //         data: {},
        //         system: "",
        //         title: data.placeholder,
        //         type: data.type,
        //         status: false,
        //         isEditable: false,
        //     }));
        //     return prevData;
        // });
        }
    }, [inputSchema]);  

    useEffect(() => {
        dispatch(setLoading(true));
        if (id) dispatch(getQuoteById({ q_id: id }));
        dispatch(setLoading(false));
    }, [dispatch, id]);

    useEffect(() => {
        if (quoteDetails) {
            setTemplateName(quoteDetails?.templateName || '');
            setInputSchema(quoteDetails?.inputJsonSchema || { data: {}, system: "" });
            setContextSchema(quoteDetails?.ContextJsonSchema || []);
            setOutputSchema(quoteDetails?.outpuJsonSchema || { data: {}, system: "" });
        }
    }, [quoteDetails]);

    const closeDialog = () => setIsDialogOpen(false);

    const handleSave = () => {
        dispatch(setLoading(true));
        const formData = {
            templateName: templateName || quoteDetails.templateName || "",
            inputJsonSchema: inputSchema || quoteDetails.inputJsonSchema || "",
            contextJsonSchema: ContextSchema || quoteDetails.contextJsonSchema || "",
            outpuJsonSchema: outputSchema || quoteDetails.outpuJsonSchema || "",
        };
        dispatch(updateQuote({ q_id: id, formData }))
            .then(() => {
                dispatch(setLoading(false));
                navigate(-1);
            })
            .catch(() => dispatch(setLoading(false)));
        closeDialog();
    };

    const addArrayItem = (path, setSchema) => {
        setSchema((prevState) => {
            const keys = path.split(".");
            const newState = { ...prevState };
            let current = newState;
            keys.forEach((key, index) => {
                if (!current[key]) {
                    current[key] = isNaN(keys[index + 1]) ? {} : [];
                }
                if (index === keys.length - 1) {
                    current[key] = [...(current[key] || []), {}];
                } else {
                    current[key] = { ...current[key] };
                    current = current[key];
                }
            });
            return newState;
        });
    };

    const removeArrayItem = (path, index, setSchema) => {
        setSchema((prevState) => {
            const keys = path.split(".");
            const newState = { ...prevState };
            let current = newState;
            keys.forEach((key, idx) => {
                if (idx === keys.length - 1 && Array.isArray(current[key])) {
                    current[key].splice(index, 1);
                } else {
                    current[key] = { ...current[key] };
                    current = current[key];
                }
            });
            return newState;
        });
    };

    const handleChange = (path, value, setSchema) => {
      const keys = path.split(".");
      setSchema((prevState) => {
        const newState = { ...prevState };
        let current = newState;
  
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            current[key] = value;
          } else {
            current[key] = { ...current[key] };
            current = current[key];
          }
        });
  
        return newState;
      });
    };

    const handleAddContextSchema = () => {
        setContextSchema((prev) => [...prev, { data: {}, system: "", title: "", status: false, isEditable: false }]);
    };

    const handleRemoveContextSchema = (index) => {
        // Remove context schema item
        setContextSchema((prev) => prev.filter((_, i) => i !== index));

        // Remove corresponding input schema data
        setInputSchema((prev) => {
            const updatedData = { ...prev };
            delete updatedData.data[index]; 
            return updatedData;
        });
    };

    const handleToggleContextSchema = (index, status) => {
        const updatedSchema = [...ContextSchema];
        updatedSchema[index].status = status;
        setContextSchema(updatedSchema);
    };

    const handleTitleChange = (index, newTitle) => {
        const updatedSchema = [...ContextSchema];
        updatedSchema[index].title = newTitle;
        setContextSchema(updatedSchema);
    };

    const handleSystemRoleChange = (index, value) => {
        setContextSchema((prev) => 
          prev.map((item, i) => (i === index ? { ...item, system: value } : item))
        );
    };

    const getValue = (path, schema) => {
        const keys = path.split(".");
        let value = schema;
        for (let key of keys) {
            value = value[key];
            if (value === undefined) return undefined;
        }
        return value;
    };

    const setValue = (path, newValue, schema) => {
        const keys = path.split(".");
        const newSchema = { ...schema };
        let current = newSchema;
        keys.forEach((key, idx) => {
            if (idx === keys.length - 1) {
                current[key] = newValue;
            } else {
                current[key] = { ...current[key] };
                current = current[key];
            }
        });
        return newSchema;
    };
    
    return (
      <>
        <Typography variant="h4" gutterBottom marginBottom={4}>
          Edit Template
        </Typography>
        <Box
          container
          sx={{ padding: 3, border: "1px solid #ddd", borderRadius: 2 }}>
          {/* Input Schema */}
          <Grid container spacing={4} sx={{ padding: 3 }}>
            <Grid size={{xs:12, md:6}}>
              <Paper elevation={3} sx={{ padding: 3, marginBottom: 2 }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  marginBottom={2}>
                  <Typography variant="h6">Input Schema</Typography>
                </Box>
                <Editor
                  schema={inputSchema.data}
                  onChange={(value) =>
                    setInputSchema((prev) => ({ ...prev, data: value }))
                  }
                />
              </Paper>
            </Grid>
  
            <Grid size={{xs:12, md:6}}>
              <Paper elevation={3} sx={{ padding: 3 }}>
                <Typography variant="h6" marginBottom={2}>
                  Define Key-Value Pair
                </Typography>
                <DynamicForm schemaString={inputSchema.data} />
              </Paper>
            </Grid>
          </Grid>
  
          {/* Context Schema */}
            {ContextSchema.map((schema, index) => (
              <Grid container spacing={4} sx={{ padding: 3 }}>
                <Grid size={{xs:12, md:6}}>
                  <Input
                    type="text"
                    placeholder="system Role"
                    sx={{ mb: 1, width: "100%" }}
                    variant="contained"
                    value={schema.system}
                    onChange={(e) =>
                      handleSystemRoleChange(index, e.target.value)
                    }
                  />
                  <Paper
                    key={index}
                    elevation={3}
                    sx={{ padding: 3, marginBottom: 2 }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      marginBottom={2}>
                      {/* Editable Title with TextField */}
                      <Grid size={{ xs: 12, md: 2 }}>
                        <FormControl fullWidth>
                          <Box display="flex" alignItems="center" sx={{ gap: 2 }}>
                            <Typography variant="h6" marginBottom={2}>
                              {schema.title}
                            </Typography>
                          </Box>
                        </FormControl>
                      </Grid>
                      {/* Toggle Switch */}
                      <Switch
                        color="primary"
                        checked={schema.status}
                        onChange={(e) =>
                          handleToggleContextSchema(index, e.target.checked)
                        }
                      />
                      <IconButton
                        color="error"
                        onClick={() => handleRemoveContextSchema(index)}>
                        <RemoveCircle />
                      </IconButton>
                    </Box>
                    <Editor
                      schema={schema.data}
                      onChange={(value) =>
                        setContextSchema((prev) =>
                         prev.map((item, i)=>
                          i === index ? {...item, data: value} : item
                         )
                        )
                      }
                    />
                  </Paper>
                </Grid>
  
                <Grid size={{xs:12, md:6}}>
                  <Paper
                    key={index}
                    elevation={3}
                    sx={{ padding: 3, marginBottom: 2 }}>
                    <Typography variant="h6" marginBottom={2}>
                      Define Key-Value Pairs
                    </Typography>
                    <FormFields
                      schema={schema.data}
                      getValue={(path) => getValue(path, ContextSchema)}
                      handleChange={(path, value) =>
                        handleChange(path, value, setContextSchema)
                      }
                      addArrayItem={(path) =>
                        addArrayItem(path, setContextSchema)
                      }
                      removeArrayItem={(path, index) =>
                        removeArrayItem(path, index, setContextSchema)
                      }
                    />
                  </Paper>
                </Grid>
              </Grid>
            ))}
  
          {/* Output Schema */}
          <Grid container spacing={4} sx={{ padding: 3 }}>
            <Grid size={{xs:12, md:6}}>
              <Input
                type="text"
                placeholder="system Role"
                sx={{ mb: 1, width: "100%" }}
                variant="contained"
                value={outputSchema?.system}
                onChange={(e) =>
                  setOutputSchema((prev) => ({ ...prev, system: e.target.value }))
                }
              />
              <Paper elevation={3} sx={{ padding: 3, marginBottom: 2 }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  marginBottom={2}>
                  <Typography variant="h6">Output Schema</Typography>
                </Box>
                <Editor
                  schema={outputSchema?.data}
                  onChange={(value) =>
                    setOutputSchema((prev) => ({ ...prev, data: value }))
                  }
                />
              </Paper>
            </Grid>
  
            <Grid size={{xs:12, md:6}}>
              <Paper elevation={3} sx={{ padding: 3 }}>
                <Typography variant="h6" marginBottom={2}>
                  Define Key-Value Pairs
                </Typography>
                <FormFields
                  schema={outputSchema?.data}
                  getValue={(path) => getValue(path, outputSchema?.data)}
                  handleChange={(path, value) =>
                    handleChange(path, value, setOutputSchema?.data)
                  }
                  addArrayItem={(path) =>
                    addArrayItem(path, setOutputSchema?.data)
                  }
                  removeArrayItem={(path, index) =>
                    removeArrayItem(path, index, setOutputSchema?.data)
                  }
                />
              </Paper>
            </Grid>
          </Grid>
          <Box
            sx={{
              justifyContent: "flex-end",
              display: "flex",
              gap: 3,
              mt: 3,
              width: "100%",
            }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsDialogOpen(true)}>
              Save Quote
            </Button>
          </Box>
        </Box>
  
        <SaveDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          templateName={templateName}
          onTemplateNameChange={setTemplateName}
          onSave={handleSave}
        />
      </>
    );
};

export default EditTem;
